import { withEngagingURL } from '../../../decorators'
import { useGenericRequestHandler } from '../../../handlers'
import type { Device, GenericHandlerValues, ToteStatus } from '../../../models'

/**
 * @type {Record<string, ToteEngagementMode>}
 */
export const ToteEngagementModeEnum = {
  AFFIRMATIVE: 'affirmative',
  ASSISTIVE: 'assistive'
}

export interface ToteStatusQueryData {
  toteStatus: ToteStatus
  device: Device
}

export type UseToteStatusQueryValues = GenericHandlerValues<
  ToteStatusQueryData,
  'POST'
>

export const useToteStatusQuery = (
  toteId: string
): UseToteStatusQueryValues => {
  const values = useGenericRequestHandler({
    route: `v1/t/status/${toteId}`,
    method: 'POST',
    options: { timeout: 25000 }
  })
  //@ts-expect-error
  return withEngagingURL(values)
}
